/**
 * Formats the span between two instants as `HH:mm`, the way the timesheet's duration column reads.
 *
 * A plain function rather than the `formatDuration` pipe, which is `standalone: false` and would
 * oblige every row component to import `SharedModule` for two lines of formatting.
 *
 * @param startIso the span's start as an ISO timestamp
 * @param endIso the span's end as an ISO timestamp
 * @returns the duration as `HH:mm`, or an empty string when either instant is unusable
 */
export function formatRowDuration(startIso: string, endIso: string): string {
    const from = Date.parse(startIso);
    const to = Date.parse(endIso);
    if (Number.isNaN(from) || Number.isNaN(to) || to < from) {
        return '';
    }

    const totalMinutes = Math.round((to - from) / 60_000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
